
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ValidationUtils } from 'src/app/shared/utils/validation.utils';

@Injectable()
export class AdminService {

  constructor(private http: HttpClient) { }


  // For Service Bulletins
  createNewSIB(bulletinData, makeName): Observable<any> {
    return this.http.post(`serviceBulletin/saveNewBulletin?makeName=${makeName}`, bulletinData, { withCredentials: true });
  }
  addBulletinDetailsToNewSIB(bulletinNumber, bulletinDetailData, makeName): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`serviceBulletin/saveNewBulletinDetail/bulletinNumber/${bulletinNumber}?makeName=${makeName}`, bulletinDetailData, { withCredentials: true });
  }

  addSupportingVideosToNewSIB(bulletinId, formData, makeName): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`serviceBulletin/videoUpdate/existingBulletinId/${bulletinId}?makeName=${makeName}`, formData, { withCredentials: true });
  }

  addSupportingMaterialsToNewSIB(bulletinId, formData, makeName): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`serviceBulletin/fileUpload/existingBulletinId/${bulletinId}?makeName=${makeName}`, formData, { withCredentials: true });
  }
  addStartAndEndDateToNewSIB(bulletinInfo): Observable<any> {
    return this.http.put('serviceBulletin/updateExistingBulletin', bulletinInfo, { withCredentials: true });
  }
  getSIBBulletinDetail(bulletinNumber, makeName): Observable<any> {
    return this.http.get(`serviceBulletin/admin/findMoreBulletinDetail/bulletinNumber/${bulletinNumber}?makeName=${makeName}`);
  }
  downloadBulletinPDF(bulletinId): Observable<Blob> {
	console.log('download pdf')
    return this.http.get(`download-bulletin/pdf/bulletinId/${bulletinId}`, { responseType: 'blob' as 'json' }).pipe(map((res: any) => {
      return new Blob([res], { type: 'application/pdf' });
    }));
  }
  downloadToolExcel(autoShip): Observable<Blob> {
    return this.http.get(`tool-report/all/download/${autoShip}`, { responseType: 'blob' as 'json' }).pipe(map((res: any) => {
      return new Blob([res], { type: 'application/vnd.ms-excel' });
    }));
  }
  updateSIB(bulletinData): Observable<any> {
    return this.http.put(`serviceBulletin/updateExistingBulletin`, bulletinData);
  }
  updateSIBDetail(bulletinData): Observable<any> {
    return this.http.put(`serviceBulletin/updateExistingBulletinDetail`, bulletinData);
  }
  updateSupportingMaterialsToNewSIB(bulletinNumber, formData, makeName): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`serviceBulletin/fileUpload/existingBulletinNumber/${bulletinNumber}?makeName=${makeName}`, formData, { withCredentials: true });
  }

  // For TRI Bulletins
  createNewTRI(bulletinData, makeName): Observable<any> {
    return this.http.post(`tri-bulletin/saveNewBulletin?makeName=${makeName}`, bulletinData, { withCredentials: true });
  }
  updateTRI(bulletinInfo): Observable<any> {
    return this.http.put('tri-bulletin/updateExistingBulletin', bulletinInfo, { withCredentials: true });
  }
  getTRIBulletinDetail(bulletinNumber, makeName): Observable<any> {
    return this.http.get(`tri-bulletin/admin/findMoreBulletinDetail/bulletinNumber/${bulletinNumber}?makeName=${makeName}`);
  }
  addBulletinDetailsToNewTRI(bulletinNumber, bulletinDetailData, makeName): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`tri-bulletin/saveNewBulletinDetail/bulletinNumber/${bulletinNumber}?makeName=${makeName}`, bulletinDetailData, { withCredentials: true });
  }
  updateTRIBulletinDetails(bulletinInfo): Observable<any> {
    return this.http.put('tri-bulletin/updateExistingBulletinDetail', bulletinInfo, { withCredentials: true });
  }
  addSupportingMaterialsToNewTRI(bulletinId, formData, makeName): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`tri-bulletin/fileUpload/existingBulletinId/${bulletinId}?makeName=${makeName}`, formData, { withCredentials: true });
  }

  addSupportingVideosToNewTRI(bulletinId, formData, makeName): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`tri-bulletin/videoUpdate/existingBulletinId/${bulletinId}?makeName=${makeName}`, formData, { withCredentials: true });
  }

  addStartAndEndDateToNewTRI(bulletinInfo): Observable<any> {
    return this.http.put('tri-bulletin/updateExistingBulletin', bulletinInfo, { withCredentials: true });
  }

  // For PBS
  createNewPartsBulletinWithFile(bulletinData, bulletinNumber): Observable<any> {
    return this.http.post(`parts-bulletin/fileUpload/newBulletinNumber/${bulletinNumber}`, bulletinData);
  }
  createNewPartsBulletin(bulletinData): Observable<any> {
    return this.http.post(`parts-bulletin/saveNewBulletin`, bulletinData);
  }
  getPBSDataWithBulletinNumber(bulletinNumber, makeName): Observable<any> {
    return this.http.get(`parts-bulletin/findOneBulletinNumber/${bulletinNumber}?makeName=${makeName}`);
  }
  findBulletinByNumberMake(bulletinNumber, makeName): Observable<any> {
    return this.http.get(`serviceBulletin/findOneBulletinNumber/${bulletinNumber}?makeName=${makeName}`);
  }
  updatePBS(bulletinData): Observable<any> {
    return this.http.put(`parts-bulletin/updateExistingBulletin`, bulletinData);
  }
  updatePBSWithFile(bulletinData, bulletinId): Observable<any> {
    return this.http.post(`parts-bulletin/fileUpload/existingById/${bulletinId}`, bulletinData);
  }
  reactivateBulletin(bulletinNumber, userEmail, makeName): Observable<any> {
    return this.http.put(`user-info/reactivateBulletinByBulletinId/${bulletinNumber}?email=${userEmail}&makeName=${makeName}`, '');
  }

  // DELETE Before
  /*
  deactivateBulletin(bulletinNumber, userEmail, makeName): Observable<any> {
    return this.http.delete(`user-info/deactivateBulletinByBulletinId/${bulletinNumber}?email=${userEmail}&makeName=${makeName}`);
  }*/

  deactivateBulletin(bulletinNumber, userEmail, makeName): Observable<any> {
    return this.http.get(`user-info/deactivateBulletinByBulletinId/${bulletinNumber}?email=${userEmail}&makeName=${makeName}`);
  }
  approveBulletin(bulletinId): Observable<any> {
    return this.http.get(`common/approveNow/bulletinId/${bulletinId}`);
  }
  // For Operating Fluid
  createNewOperatingFluid(bulletinData): Observable<any> {
    return this.http.post(`operating-fluid/saveNewOperatingFluid`, bulletinData);
  }
  createNewOperatingFluidWithFile(bulletinData, groupNumber): Observable<any> {
    return this.http.post(`operating-fluid/fileUpload/newMainGroupNumber/${groupNumber}`, bulletinData);
  }
  updateOperatingFluid(bulletinData): Observable<any> {
    return this.http.put(`operating-fluid/updateExistingOperatingFluid`, bulletinData);
  }
  updateOperatingFluidWithFile(bulletinData, bulletinId): Observable<any> {
    return this.http.post(`operating-fluid/fileUpload/existingById/${bulletinId}`, bulletinData);
  }
  getOPeratingFluidData(groupNumber, makeName): Observable<any> {
    return this.http.get(`operating-fluid/findOneByMainGroupNumber/${groupNumber}?makeName=${makeName}`);
  }
  reactivateOperatingFluids(groupCode, userEmail, makeName): Observable<any> {
    return this.http.put(`user-info/reactivateOperatingFluidByMainGroupNumber/${groupCode}?email=${userEmail}&makeName=${makeName}`, '');
  }
  // DELETE Before
  /*
  deactivateOperatingFluids(groupCode, userEmail, makeName): Observable<any> {
    return this.http.delete(`user-info/deactivateOperatingFluidByMainGroupNumber/${groupCode}?email=${userEmail}&makeName=${makeName}`);
  }*/

  deactivateOperatingFluids(groupCode, userEmail, makeName): Observable<any> {
    return this.http.get(`user-info/deactivateOperatingFluidByMainGroupNumber/${groupCode}?email=${userEmail}&makeName=${makeName}`);
  }

  // For Tech training Manual
  createNewTechTrainingManual(bulletinData): Observable<any> {
    return this.http.post(`tech-training-manual/saveNewTechTrainingManual`, bulletinData);
  }
  createNewTechTrainingManualWithFile(bulletinData, docNumber): Observable<any> {
    return this.http.post(`tech-training-manual/fileUpload/newDocumentNumber/${docNumber}`, bulletinData);
  }
  getTechTrainingManualInfo(docNumber, makeName): Observable<any> {
    return this.http.get(`tech-training-manual/findOneByDocumentNumber/${docNumber}?makeName=${makeName}`);
  }
  updateTechTrainingManual(bulletinData): Observable<any> {
    return this.http.put(`tech-training-manual/updateExistingTechTrainingManual`, bulletinData);
  }
  updateTechTrainingManualWithFile(bulletinData, bulletinId): Observable<any> {
    return this.http.post(`tech-training-manual/fileUpload/existingById/${bulletinId}`, bulletinData);
  }
  reactivateTechTrainingManual(docNumber, userEmail, makeName): Observable<any> {
    return this.http.put(`user-info/reactivateTechTrainingManualByNumber/${docNumber}?email=${userEmail}&makeName=${makeName}`, '');
  }
  // DELETE Before
  /*
  deactivateTechTrainingManual(docNumber, userEmail, makeName): Observable<any> {
    return this.http.delete(`user-info/deactivateTechTrainingManualByNumber/${docNumber}?email=${userEmail}&makeName=${makeName}`);
  }*/

  deactivateTechTrainingManual(docNumber, userEmail, makeName): Observable<any> {
    return this.http.get(`user-info/deactivateTechTrainingManualByNumber/${docNumber}?email=${userEmail}&makeName=${makeName}`);
  }

  // For Body and Paint Manual
  createNewBodyAndPaintManual(bulletinData): Observable<any> {
    return this.http.post(`body-and-paint-manual/saveNewBodyAndPaintManual`, bulletinData);
  }
  createNewBodyAndPaintManualWithFile(bulletinData, docNumber): Observable<any> {
    return this.http.post(`body-and-paint-manual/fileUpload/newDocumentNumber/${docNumber}`, bulletinData);
  }
  getBodyAndPaintManualInfo(docNumber, makeName): Observable<any> {
    return this.http.get(`body-and-paint-manual/findOneByDocumentNumber/${docNumber}?makeName=${makeName}`);
  }
  updateBodyAndPaintManual(bulletinData): Observable<any> {
    return this.http.put(`body-and-paint-manual/updateExistingBodyAndPaintManual`, bulletinData);
  }
  updateBodyAndPaintManualWithFile(bulletinData, bulletinId): Observable<any> {
    return this.http.post(`body-and-paint-manual/fileUpload/existingById/${bulletinId}`, bulletinData);
  }
  reactivateBodyAndPaintManual(docNumber, userEmail, makeName): Observable<any> {
    return this.http.put(`user-info/reactivateBodyAndPaintManualByNumber/${docNumber}?email=${userEmail}&makeName=${makeName}`, '');
  }
  // DELETE Before
  /*
  deactivateBodyAndPaintManual(docNumber, userEmail, makeName): Observable<any> {
    return this.http.delete(`user-info/deactivateBodyAndPaintManualByNumber/${docNumber}?email=${userEmail}&makeName=${makeName}`);
  }*/
  deactivateBodyAndPaintManual(docNumber, userEmail, makeName): Observable<any> {
    return this.http.get(`user-info/deactivateBodyAndPaintManualByNumber/${docNumber}?email=${userEmail}&makeName=${makeName}`);
  }
  // For Equip Manual
  createNewEquipementManual(bulletinData): Observable<any> {
    return this.http.post(`equipment-manual/saveNewEquipmentManual`, bulletinData);
  }
  createNewEquipementManualWithFile(bulletinData, docNumber): Observable<any> {
    return this.http.post(`equipment-manual/fileUpload/newDocumentNumber/${docNumber}`, bulletinData);
  }
  getEquipmentManualInfo(docNumber, makeName): Observable<any> {
    return this.http.get(`equipment-manual/findOneByDocumentNumber/${docNumber}?makeName=${makeName}`);
  }
  updateEquipmentManual(bulletinData): Observable<any> {
    return this.http.put(`equipment-manual/updateExistingEquipmentManual`, bulletinData);
  }
  updateEquipmentManualWithFile(bulletinData, bulletinId): Observable<any> {
    return this.http.post(`equipment-manual/fileUpload/existingById/${bulletinId}`, bulletinData);
  }
  reactivateEquipmentManual(docNumber, userEmail, makeName): Observable<any> {
    return this.http.put(`user-info/reactivateEquipmentManualByNumber/${docNumber}?email=${userEmail}&makeName=${makeName}`, '');
  }
  // DELETE Before
  /*
  deactivateEquipmentManual(docNumber, userEmail, makeName): Observable<any> {
    return this.http.delete(`user-info/deactivateEquipmentManualByNumber/${docNumber}?email=${userEmail}&makeName=${makeName}`);
  }*/
  deactivateEquipmentManual(docNumber, userEmail, makeName): Observable<any> {
    return this.http.get(`user-info/deactivateEquipmentManualByNumber/${docNumber}?email=${userEmail}&makeName=${makeName}`);
  }

  // For Tech Doc
  createNewTechnicalDocument(bulletinData): Observable<any> {
    return this.http.post(`tech-doc/saveNewTechDocumentation`, bulletinData);
  }
  createNewTechnicalDocumentWithFile(bulletinData, docNumber): Observable<any> {
    return this.http.post(`tech-doc/fileUpload/newDocumentNumber/${docNumber}`, bulletinData);
  }
  updateTechnicalDocument(bulletinData): Observable<any> {
    return this.http.put(`tech-doc/updateExistingTechDocumentation`, bulletinData);
  }
  updateTechnicalDocumentWithFile(bulletinData, docNumber): Observable<any> {
    return this.http.post(`tech-doc/fileUpload/existingById/${docNumber}`, bulletinData);
  }
  getTechDocInfo(docNumber, makeName): Observable<any> {
    return this.http.get(`tech-doc/findOneByDocumentNumber/${docNumber}?makeName=${makeName}`);
  }
  // DELETE Before
  /*
  deactivateTechDoc(documentNumber, userEmail, makeName): Observable<any> {
    return this.http.delete(`user-info/deactivateTechDocByNumber/${documentNumber}?email=${userEmail}&makeName=${makeName}`);
  }*/
  deactivateTechDoc(documentNumber, userEmail, makeName): Observable<any> {
    return this.http.get(`user-info/deactivateTechDocByNumber/${documentNumber}?email=${userEmail}&makeName=${makeName}`);
  }
  reactivateTechDoc(documentNumber, userEmail, makeName): Observable<any> {
    return this.http.put(`user-info/reactivateTechDocByNumber/${documentNumber}?email=${userEmail}&makeName=${makeName}`, '');
  }

  // api to add new bulletin (quick)
  createNewBulletin(bulletinData, bulletinNumber): Observable<any> {
    return this.http.post(`common/uploadNewBulletin/${bulletinNumber}`, bulletinData);
  }

  // For FAQ and TopLink
  createNewFAQ(faqData): Observable<any> {
    return this.http.post(`faq/fileUpload/newFaq`, faqData);
  }
  updateFAQ(formData, docId): Observable<any> {
    return this.http.post(`faq/fileUpload/existingById/${docId}`, formData);
  }
  reactivateFAQ(docId, userEmail, makeName): Observable<any> {
    return this.http.put(`faq/reactivateFAQById/${docId}?email=${userEmail}&makeName=${makeName}`, '');
  }

  deactivateFAQ(docId, userEmail, makeName): Observable<any> {
    return this.http.get(`faq/deactivateFAQById/${docId}?email=${userEmail}&makeName=${makeName}`);
  }

  // For TopLink
  createNewTopLink(topLinkData): Observable<any> {
    return this.http.post(`top-link/fileUpload/newTopLink`, topLinkData);
  }
  updateTopLink(formData, docId): Observable<any> {
    return this.http.post(`top-link/fileUpload/existingById/${docId}`, formData);
  }
  reactivateTopLink(docId, userEmail, makeName): Observable<any> {
    return this.http.put(`top-link/reactivateTopLinkById/${docId}?email=${userEmail}&makeName=${makeName}`, '');
  }
  // DELETE Before
  /*
  deactivateTopLink(docId, userEmail, makeName): Observable<any> {
    return this.http.delete(`top-link/deactivateTopLinkById/${docId}?email=${userEmail}&makeName=${makeName}`);
  }
  */
  deactivateTopLink(docId, userEmail, makeName): Observable<any> {
    return this.http.get(`top-link/deactivateTopLinkById/${docId}?email=${userEmail}&makeName=${makeName}`);
  }
  // Create New Video
  createNewVideo(videoObj): Observable<any> {
    return this.http.post(`video/saveNewVideo`, videoObj);
  }
  // Create New Noise Catalog
  createNewNoiseCatalog(noiseCatalogObj): Observable<any> {
    return this.http.post(`noiseCatalog/saveNewNoiseCatalog`, noiseCatalogObj);
  }
  createNewScopePattern(scopePatternObj): Observable<any> {
    return this.http.post(`scopePattern`, scopePatternObj);
  }
  updateScopePatternWithFile(fileObj, scopePatternId): Observable<any> {
    return this.http.post(`scopePattern/file/${scopePatternId}`, fileObj);
  }
  createNewVideoWithFile(fileObj, videoNumber, makeName): Observable<any> {
    return this.http.post(`video/fileUpload/videoNumber/${videoNumber}?makeName=${makeName}`, fileObj);
  }
  getVideoInfo(docNumber, makeName): Observable<any> {
    return this.http.get(`video/findOneVideoNumber/${docNumber}?makeName=${makeName}`);
  }

  getNoiseCatalogInfo(docNumber, makeName): Observable<any> {
    return this.http.get(`noiseCatalog/findOneNoiseCatalogNumber/${docNumber}?makeName=${makeName}`);
  }
  getScopePatternInfo(docNumber, makeName): Observable<any> {
    return this.http.get(`scopePattern/${docNumber}`);
  }
  updateVideo(videoData): Observable<any> {
    return this.http.put(`video/updateExistingVideo`, videoData);
  }

  updateNoiseCatalog(noiseCatalogObj): Observable<any> {
    return this.http.put(`noiseCatalog/updateExistingNoiseCatalog`, noiseCatalogObj);
  }
  updateScopePattern(scopePatternObj): Observable<any> {
    return this.http.put(`scopePattern/${scopePatternObj.id}`, scopePatternObj);
  }

  updateVideoWithFile(videoData, videoId, makeName): Observable<any> {
    return this.http.post(`video/fileUpload/videoNumber/${videoId}?makeName=${makeName}`, videoData);
  }

  reactivateVideo(videoNumber, userEmail, makeName): Observable<any> {
    return this.http.put(`user-info/reactivateVideoByVideoNumber/${videoNumber}?email=${userEmail}&makeName=${makeName}`, '');
  }

  updateNoiseCatalogActiveStatus(noiseCatalogNumber, userEmail, makeName,isActive): Observable<any> {
    return this.http.put(`user-info/updateNoiseCatalogActiveStatus/${noiseCatalogNumber}?email=${userEmail}&makeName=${makeName}&isActive=${isActive}`, '');
   // return this.http.put(`user-info/updateNoiseCatalogActiveStatus/${noiseCatalogNumber}?makeName=${makeName}&isActive=${isActive}`, '');
  }
  updateScopePatternActiveStatus(scopePatternNumber, userEmail, makeName,isActive): Observable<any> {
    return this.http.put(`scopePattern/status/${scopePatternNumber}`, '');
   // return this.http.put(`user-info/updateNoiseCatalogActiveStatus/${noiseCatalogNumber}?makeName=${makeName}&isActive=${isActive}`, '');
  }

  // DELETE Before
  /*
  deactivateVideo(videoNumber, userEmail, makeName): Observable<any> {
    return this.http.delete(`user-info/deactivateVideoByVideoNumber/${videoNumber}?email=${userEmail}&makeName=${makeName}`);
  }*/
  deactivateVideo(videoNumber, userEmail, makeName): Observable<any> {
    return this.http.get(`user-info/deactivateVideoByVideoNumber/${videoNumber}?email=${userEmail}&makeName=${makeName}`);
  }

  getAllVideoNumbers(makeName): Observable<any> {
    return this.http.get(`video/findAllVideoNumberList?makeName=${makeName}`);
  }

  // Create New Tool Report
  createNewToolReport(toolObj): Observable<any> {
    return this.http.post(`tool-report/saveNewToolReport`, toolObj);
  }
  createNewToolReportWithFile(fileObj, toolReportNumber, makeName): Observable<any> {
    return this.http.post(`tool-report/fileUpload/toolReportNumber/${toolReportNumber}?makeName=${makeName}`, fileObj);
  }
  getAllToolReportPartNumbers(makeName): Observable<any> {
    return this.http.get(`tool-report/findAllOrderPartNumberList?makeName=${makeName}`);
  }
  getToolReportWithPartNumber(partNumber, makeName): Observable<any> {
    return this.http.get(`tool-report/findOneByToolReportNumber/${partNumber}?makeName=${makeName}`);
  }
  updateToolReport(toolReportData): Observable<any> {
    return this.http.put(`tool-report/updateExistingToolReport`, toolReportData);
  }
  updateToolReportWithFile(toolReportData, partNumber, makeName): Observable<any> {
    return this.http.post(`tool-report/fileUpload/toolReportNumber/${partNumber}?makeName=${makeName}`, toolReportData);
  }
  reactivateToolReport(partNumber, userEmail, makeName): Observable<any> {
    return this.http.put(`user-info/reactivateToolReportByPartNumber/${partNumber}?email=${userEmail}&makeName=${makeName}`, '');
  }

  // DELETE Before
  /*
  deactivateToolReport(documentNumber, userEmail, makeName): Observable<any> {
    return this.http.delete(`user-info/deactivateToolReportByPartNumber/${documentNumber}?email=${userEmail}&makeName=${makeName}`);
  }*/
  deactivateToolReport(documentNumber, userEmail, makeName): Observable<any> {
    return this.http.get(`user-info/deactivateToolReportByPartNumber/${documentNumber}?email=${userEmail}&makeName=${makeName}`);
  }

  // Create New OBD Report
  createNewOBD(obdObj): Observable<any> {
    return this.http.post(`onboard-diagnostic/saveNewOnboardDiagnostic`, obdObj);
  }
  createNewOBDWithFile(fileObj, docNumber, makeName): Observable<any> {
    return this.http.post(`onboard-diagnostic/fileUpload/documentNumber/${docNumber}?makeName=${makeName}`, fileObj);
  }
  getObdDocumentWithDocumentNumber(documentNumber, makeName): Observable<any> {
    return this.http.get(`onboard-diagnostic/findOneByDocumentNumber/${documentNumber}?makeName=${makeName}`);
  }
  updateOBD(obdDocData): Observable<any> {
    return this.http.put(`onboard-diagnostic/updateExistingOnboardDiagnostic`, obdDocData);
  }
  updateOBDWithFile(obdDocData, docId, makeName): Observable<any> {
    return this.http.post(`onboard-diagnostic/fileUpload/documentNumber/${docId}?makeName=${makeName}`, obdDocData);
  }
  reactivateOBD(documentNumber, userEmail, makeName): Observable<any> {
    return this.http.put(`user-info/reactivateOnboardDiagnosticByNumber/${documentNumber}?email=${userEmail}&makeName=${makeName}`, '');
  }

  // DELETE Before
  /*
  deactivateOBD(documentNumber, userEmail, makeName): Observable<any> {
    return this.http.delete(`user-info/deactivateOnboardDiagnosticByNumber/${documentNumber}?email=${userEmail}&makeName=${makeName}`);
  }*/

  deactivateOBD(documentNumber, userEmail, makeName): Observable<any> {
    return this.http.get(`user-info/deactivateOnboardDiagnosticByNumber/${documentNumber}?email=${userEmail}&makeName=${makeName}`);
  }

  // messages
  createNewMessage(messageObj): Observable<any> {
    return this.http.post(`message/addNewMessage`, messageObj);
  }
  updateMessage(messageObj): Observable<any> {
    return this.http.put(`message/updateExistingMessage`, messageObj);
  }
  getAllMessages(makeName): Observable<any> {
    return this.http.get(`message/active/all?makeName=${makeName}`);
  }

  getAllPublicMessages(makeName): Observable<any> {
    return this.http.get(`public/message/active/all?makeName=${makeName}`);
  }

  getAllMessagesAdmin(makeName): Observable<any> {
    return this.http.get(`message/all?makeName=${makeName}`);
  }
  findMessageById(messageId): Observable<any> {
    const sanitizedMessageId = ValidationUtils.sanitizeQID(messageId);
    return this.http.get(`message/findOneMessageById/${sanitizedMessageId}`);
  }
  reactivateMessage(messageId, email, makeName): Observable<any> {
    return this.http.put(`message/reactivateMessageById/${messageId}?email=${email}&makeName=${makeName}`, '');
  }
  // DELETE Before
  /*
  deactivateMessage(messageId, email, makeName): Observable<any> {
    return this.http.delete(`message/deactivateMessageById/${messageId}?email=${email}&makeName=${makeName}`);
  }
  */
  deactivateMessage(messageId, email, makeName): Observable<any> {
    return this.http.get(`message/deactivateMessageById/${messageId}?email=${email}&makeName=${makeName}`);
  }

  deleteSIBSupportDocuments(bulletinId, makeName): Observable<any> {
    return this.http.get(`serviceBulletin/deleteSupport/existingBulletinId/${bulletinId}?makeName=${makeName}`, { withCredentials: true });
  }

  deleteTRISupportDocuments(bulletinId, makeName): Observable<any> {
    return this.http.get(`tri-bulletin/deleteSupport/existingBulletinId/${bulletinId}?makeName=${makeName}`, { withCredentials: true });
  }

  getBulletinFullRatingReport(makeName, priorDays): Observable<any> {
    return this.http.get(`starReport/report/bulletinFullRatingReport/${makeName}?priorDays=${priorDays}`);
  }

  getBulletinAvgRatingReport(makeName, priorDays): Observable<any> {
    return this.http.get(`starReport/report/bulletinAvgRatingReport/${makeName}?priorDays=${priorDays}`);
  }

  downloadFullStarReportExcel(makeName, priorDays): Observable<any> {
    return this.http.get(`starReport/report/downloadBulletinFullRatingReport/${makeName}?priorDays=${priorDays}`, { responseType: 'blob' as 'json' }).pipe(map((res: any) => {
      return new Blob([res], { type: 'application/vnd.ms-excel' });
    }));
  }

  submitBulletinRating(bulletinId, ratingNum, comments): Observable<any> {
    return this.http.put(`starReport/saveNewBulletinRatingInfo/${bulletinId}/${ratingNum}?comments=${comments}`, '');
  }

  getBulletinRatingDetails(bulletinId): Observable<any> {
    return this.http.get(`starReport/getBulletinRatingDetail/${bulletinId}`);
  }

  downloadAvgStarReportExcel(makeName, priorDays): Observable<any> {
    return this.http.get(`starReport/report/downloadBulletinAvgRatingReport/${makeName}?priorDays=${priorDays}`, { responseType: 'blob' as 'json' }).pipe(map((res: any) => {
      return new Blob([res], { type: 'application/vnd.ms-excel' });
    }));
  }


  getErrorReportData(): Observable<any> {
    return this.http.get(`serviceBulletin/errorViewList`);
  }

  getSum(value: any): any {
    let sumArr = value.reduce((acc, cur) => {
      for (let key in cur) {
        if (key === 'total' || key === 'success' || key === 'failed') {
          if (acc[key]) {
            acc[key] += cur[key]
          } else {
            acc[key] = cur[key]
          }
        }
      }
      return acc;
    }, {})
    return sumArr;
  }

}
